// @ts-nocheck
//eslint-disable-next-line

"use strict";
import CodeMirror from "codemirror";
import "codemirror/mode/sql/sql";
var Pos = CodeMirror.Pos;
/**
 * 从sql.js里获取keyword数组
 * @param {Object} editor
 */
function getKeywords(editor) {
  var mode = editor.doc.modeOption;
  if (mode === "sql") mode = "text/x-sql";
  return CodeMirror.resolveMode(mode).keywords;
}

function hintSql(editor, keywords, tableKeywords, getToken, options) {
  // 处理hint的核心函数
  // Find the token at the cursor，获取当前光标指定的字符串
  var cur = editor.getCursor(),
    token = getToken(editor, cur);
  return {
    list: getCompletions(token, keywords, tableKeywords, options),
    from: Pos(cur.line, fetchStartPoint(token)), // 字符串拼接的初始位置，这个很重要
    to: Pos(cur.line, token.end)
  };
}
/**
 * 字符拼接位置
 * @param {Object} token
 */
function fetchStartPoint(token) {
  if (token.string[0] === ".") {
    return token.start + 1;
  }
  return token.start;
}

function sqlHint(editor, options) {
  var keywords = wordToArr(getKeywords(editor));
  if (CodeMirror.keywords) {
    keywords = keywords.concat(CodeMirror.keywords);
  }
  return hintSql(
    editor,
    keywords,
    CodeMirror.tableKeywords,
    function(e, cur) {
      return e.getTokenAt(cur);
    },
    options
  );
}
CodeMirror.registerHelper("hint", "sql", sqlHint);
/**
 * 得到匹配的关键字数组
 * @param {Object} token
 * @param {Object} keywords
 * @param {Object} tableKeywords
 * @param {Object} options
 */
function getCompletions(token, keywords) {
  // var found = new Set(),
  // var result = null;

  var regexp = new RegExp(
    "\\b" + getWord(token.string, token.end) + "\\w+\\.?\\b",
    "gi"
  );
  var list = keywords.filter(item => {
    if ((item.name && regexp.test(item.name)) || regexp.test(item)) {
      return item;
    }
  });
  return list;
  // result = keywords.match(regexp);

  // if (result && result.length) {
  //   for (var i = 0; i < result.length; i++) {
  //     found.add(result[i]);
  //   }
  // }
  // return Array.from(found).sort(a => {
  //   if (a[0] === '.') {
  //     return -1;
  //   } else {
  //     return 1;
  //   }
  // });
}
/**
 * 获取当前字符串
 * @param {Object} str 当前行字符串
 * @param {Object} end 结束位置
 */
function getWord(str, end) {
  return str.substring(str.lastIndexOf(".") + 1, end);
}
/**
 * 将wordlist拼成字符串
 * @param {Object} wordlist
 */
function wordToArr(wordlist) {
  var arr = [];
  for (var word in wordlist) {
    // str += word + ' ';
    arr.push({
      name: word,
      text: word,
      type: "SQL",
      render: keyRander
    });
  }
  return arr;
}
/*
 * render方法
 */
function keyRander(elt, data, cur) {
  var name = document.createElement("span");
  name.innerText = cur.name;
  name.className = "name-type";
  elt.appendChild(name);
  var span = document.createElement("span");
  span.innerText = cur.type;
  span.className = "key-type";
  elt.appendChild(span);
}
